// extracted by mini-css-extract-plugin
module.exports = {"autoResize":"FullViewer_autoResize__1zZ2A","spinner":"FullViewer_spinner__3BvWA"};